export function transformEnum(_enum: any, value: number): string {
    const enumKey =
        Object.keys(_enum).find(
            (key: string) => (_enum as any)[key] === value
        ) || 'error';
    return enumKey;
}

export function getEnumSelection(_enum: any): {
    name: string;
    value: number;
}[] {
    return Object.keys(_enum)
        .filter(StringIsNumber)
        .map((key: any) => {
            return { name: _enum[key], value: key };
        });
}

export function getEnumIndex(_enum: any, item: any): number {
    return getEnumKeyValue(_enum, item).key;
}

export function getEnumKeyValue(_enum: any, item: any): { value: string; key: number; } {
    return {
        value: _enum[item],
        key: item,
    };
}    

const StringIsNumber = (value: any) => isNaN(Number(value)) === false;